<template lang="pug">
div
    v-card(v-if='!items')
        v-alert(type='warning') Error loading details
    v-skeleton-loader(v-else :loading='loading' type='table')
        v-data-table.elevation-0.pt-4.base-data-table(
            v-bind='$attrs'
            density='compact'
            hover
            :items='items'
            :items-per-page='numItemsPerPage'
            :hide-default-footer='!pagination'
            :headers='headers'
            :no-data-text='noDataText'
            :search='search'
            :loading='loading'
            :loading-text='loadingText'
            fixed-header
            :height='height'
        )
            template(v-for='slot in Object.keys($slots)' :slot='slot' v-slot:[slot]='scope')
                slot(:name='slot' v-bind='scope')
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'BaseDataTable',
    inheritAttrs: false,
    props: {
        items: {
            type: Array,
            required: true,
        },
        headers: {
            type: Array,
            required: true,
        },
        // Props can no longer pass through to v-data-table in Vue3
        // itemKey: String,
        dataCy: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        noDataText: {
            type: String,
            default: undefined,
        },
        search: {
            type: String,
            default: undefined,
        },
        loadingText: {
            type: String,
            default: undefined,
        },
        height: {
            // In the absence of a provided height, the table's height should auto-adjust to the contents
            type: String,
            default: undefined,
        },
        numItemsAboveWhichToTriggerPagination: {
            type: Number,
            default: 50,
        },
        initialNumItemsPerPageIfPagination: {
            type: Number,
            default: 10,
        },
    },
    computed: {
        pagination(): boolean {
            return this.items.length > this.numItemsAboveWhichToTriggerPagination;
        },
        numItemsPerPage(): number {
            return this.pagination ? this.initialNumItemsPerPageIfPagination : -1;
        },
    },
});
</script>
<style scoped>
.base-data-table {
    overflow-y: auto; /* set overflow-y to auto to enable vertical scrolling */
}
</style>
